<template>
<v-flex :class="classes" >
  <v-text-field
      v-model="fieldValue"
      :label="label"
      :required="required"
      :disabled="disabled"
      :hint="hint"
      :error-messages="errorMessages"
      :type="type"
      :counter="count"
     />
</v-flex>
</template>

<script>
import FieldMixin from '@/components/form/FieldMixin'

export default {
  mixins: [FieldMixin],
  computed: {
    useCounter () { return this.type === 'password' },
    count () { return this.type === 'password' ? 7 : false },
  },
}
</script>
